import React from "react";
import PropTypes from "prop-types";
import ConfirmModal from "@Modals/ConfirmModal";

const ConfirmModalWrapper = ({ open, onConfirm, onDismiss, header, content, focus }) => {
	return (
		open && (
			<ConfirmModal
				visible
				icon="exclamation circle"
				header={header}
				focus={focus}
				buttonLabel="Eliminar"
				content={content}
				onConfirm={onConfirm}
				onDismiss={onDismiss}
				centerModal
			/>
		)
	);
};

ConfirmModalWrapper.propTypes = {
	open: PropTypes.bool.isRequired,
	onConfirm: PropTypes.func.isRequired,
	onDismiss: PropTypes.func.isRequired,
	header: PropTypes.string.isRequired,
	content: PropTypes.string.isRequired,
	focus: PropTypes.string,
};

export default ConfirmModalWrapper;
